import React from 'react';

import { Container, Row, Col } from '@ott/grid';
import AppGallery from '@ott/icon-app-gallery';
import AppStore from '@ott/icon-appstore';
import GooglePlay from '@ott/icon-google-play';
import { l10n } from '@ott/l10n';

import QrCode from './blocks/QrCode';

import styles from './AppsSection.scss';

const AppsSection = () => {
  const appLink = new URL('https://12trip.onelink.me/CGkl');
  const pathSegments = typeof window !== 'undefined' ? window.location.pathname.split('/') : [];
  const locale = pathSegments[1];
  const section = pathSegments[2];

  /**
   * PID — это уникальный идентификатор медиа-источника
   */
  appLink.searchParams.set('pid', 'footer');
  /**
   * Аффилиат канал
   */
  appLink.searchParams.set('af_channel', 'ott_website');
  /**
   * Язык клиента
   */
  appLink.searchParams.set('af_adset', locale || 'ru');
  /**
   * Подраздел сайта
   */
  appLink.searchParams.set('c', section || 'index');

  const url = appLink.toString();

  return (
    <div className={styles.container}>
      <Container>
        <Row>
          <Col desktop={6} mobile={4}>
            <div className={styles.title}>{l10n('footer.mobileAppTitle')}</div>
            <div className={styles.appsContainer}>
              <a className={styles.appsLink} target="_blank" href={url}>
                <AppStore />
              </a>
              <a className={styles.appsLink} target="_blank" href={url}>
                <GooglePlay />
              </a>
              <a className={styles.appsLink} target="_blank" href={url}>
                <AppGallery />
              </a>
            </div>
          </Col>
          <Col desktop={6} mobile={0}>
            <div className={styles.qrCodeContainer}>
              <QrCode />
              <div>
                <div className={styles.title}>{l10n('footer.qrCodeTitle')}</div>
                <div className={styles.text}>{l10n('footer.qrCodeTip')}</div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default React.memo(AppsSection);
